<template>
  <footer>
    <a href="http://blog.fanbin.ink/" target="_blank">技术博客</a>&nbsp;|&nbsp;
    <a href="https://juejin.cn/user/3755587450179965" target="_blank">掘金主页</a>&nbsp;|&nbsp;
    <a href="https://developer.aliyun.com/profile/expert/rxw2ojcr35q6y" target="_blank">阿里云开发者社区主页</a>
    <br/>
    &nbsp;
    <br/>
    Copyright ©2020 时间箭头 All rights reserved.
    <br/>
    <a href="https://beian.miit.gov.cn" target="_blank">晋ICP备 2023017528号-1</a>
    <br/>
    <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=14010502051301"
       style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
      <img src="@/assets/image/beian.png" style="float:left;" alt="备案图标"/>
      <p style="float:left;height:20px;line-height:20px;margin: 0 0 0 5px;">晋公网安备 14010502051301号</p></a>
  </footer>
</template>

<script>
export default {
  name: "Footer"
}
</script>

<style scoped>
footer {
  --text-color: rgba(0, 0, 0, .75);
}

@media (prefers-color-scheme: dark) {
  footer {
    --text-color: rgba(255, 255, 255, .75);
  }
}

footer {
  color: var(--text-color);
  font-weight: 100;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  margin: 80px auto;
}

a {
  color: var(--text-color);
  text-decoration-line: none;
}
</style>